import { useMemo } from 'react';
import { connect } from 'react-bootstrap-formutil';
import FormGroup from 'components/FormGroup';
import UploadId, { getFieldNameOfFiles, LabelFieldEnum } from 'components/forms/UploadID';
import FormSelect from 'components/FormSelect';
import { Fade } from 'components/Transition';
import { printf } from 'utils/i18n';
import { chnExemptionTypeOptions, getExtraLabelFields } from './helper';
import { PicExemptionEnum, UploadExemptionProps } from './type';

const needFiles: LabelFieldEnum[] = [LabelFieldEnum.PIC_EXEMPTION];

/**
 * @description 豁免证明上传组件, 包含豁免证明类型和豁免证明文件上传
 */
const UploadExemption: React.FC<UploadExemptionProps> = ({ customerExemptionType, $formutil }) => {
    const { pic_exemption_type: formPicExemptionType } = $formutil.$params;
    const extraLabelFields = useMemo(
        () => getExtraLabelFields(needFiles, formPicExemptionType),
        [formPicExemptionType]
    );

    return (
        <div className="upload-exemption-root">
            <FormGroup<PicExemptionEnum>
                name="pic_exemption_type"
                checker={value => !!value || printf(__('请选择%s'), __('证明类型').toLowerCase())}
                label={__('证明类型')}
                // 如果接口没有值, 默认境外券商证明
                $defaultValue={customerExemptionType || PicExemptionEnum.OTHER_BROKER_PROOF}
                $onFieldChange={value => {
                    if (value) {
                        // 更换证明类型之后, 清空证明文件
                        const resetFormValue = getFieldNameOfFiles(needFiles).reduce((pre, cur) => {
                            pre[cur] = '';

                            return pre;
                        }, {});

                        $formutil.$setValues(resetFormValue);
                    }
                }}>
                <FormSelect
                    options={chnExemptionTypeOptions}
                    placeholder={printf(__('请选择%s'), __('证明类型').toLowerCase())}
                    // 只有在部分存量用户没有豁免证明类型的时候, 才可以选择
                    disabled={!!customerExemptionType}
                />
            </FormGroup>
            <Fade in={Boolean(formPicExemptionType)} exit={false}>
                <UploadId uploadFiles={needFiles} extraLabelFields={extraLabelFields} />
            </Fade>
        </div>
    );
};

export default connect(UploadExemption);
export * from './type';
